/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Radio from '@material-ui/core/Radio';
import { Button } from '@material-ui/core';
import {
  color,
  desktopVW,
  mobileVW,
  font,
  introSm,
  maxTablet,
  minTablet,
} from '../../styles';
import { Typography } from '../../shared/Typography';
import { getUniqueListBy } from '../../utils';

export const PackageSelector = ({
  data, totalDays, quantity, product, getProducts, setProducts,
} : any) => {
  console.log(product);

  if (!product) return null;

  const { variants } = product.node;
  const [selectedValue, setSelectedValue] = useState('2');

  const selectedProduct = variants.filter(({ title } : { title: string }) => Number(title) === parseInt(totalDays, 10))[0] || {};

  useEffect(() => {
    if (!getProducts.length) return;
    setTimeout(() => setProducts(getUniqueListBy([...getProducts, { ...product.node, quantity: 2 }], 'title')));
  }, [getProducts.length > 0]);

  const handleClick = (transmittors : number) => {
    setProducts(getUniqueListBy([...getProducts, { ...product.node, quantity: transmittors }], 'title'));
  };

  const handleChange = (transmittors : any) => {
    setSelectedValue(transmittors.toString());
  };

  return (
    <StyledPackageSelector>
      {data.packages.map(({ transmittors } : any) => (
        <StyledCard key={transmittors} background={transmittors.toString() === selectedValue} onClickCapture={() => handleChange(transmittors)} onClick={() => handleClick(transmittors)}>
          {transmittors === 2 && (
            <MostSelected size="link-sm" variants="div">
              Meest gekozen pakket
            </MostSelected>
          )}
          <StyledRadio
            // color={'red'}
            checked={selectedValue === transmittors.toString()}
            onChange={() => handleChange(transmittors)}
            value={transmittors}
            name="radio-button"
            inputProps={{ 'aria-label': transmittors }}
          />
          <StyledIcon>
            {quantity || '0'}
          </StyledIcon>
          <StyledTypography colorStyle={transmittors.toString() === selectedValue} size="intro-is-rg">
            Koptelefoons
            +
            {' '}
            {transmittors}
            {' '}
            zender
          </StyledTypography>
          <StyledBody colorStyle={transmittors.toString() === selectedValue}>
            {totalDays}
            {' '}
            dagen,
            {' '}
            {quantity}
            {' '}
            koptelefoons,
            {' '}
            {transmittors}
            {' '}
            zender
          </StyledBody>
          <StyledTypography colorStyle={transmittors.toString() === selectedValue} size="intro-is-rg">
            €
            {' '}
            {transmittors * selectedProduct.price}
            ,-
          </StyledTypography>
        </StyledCard>
      ))}
    </StyledPackageSelector>
  );
};

const StyledPackageSelector = styled.div`
  margin-top: ${mobileVW(30)};
  position: relative;

  ${minTablet} {
    margin-top: ${desktopVW(30)};
    display: flex;
    justify-content: space-between;
  }
`;

const StyledRadio = styled(Radio)`
  position: absolute !important;
  top: ${desktopVW(10)};
  left: ${desktopVW(10)};
`;

const StyledCard = styled(Button)`
  position: relative;
  ${({ background } : {background: boolean}) => (background ? (` 
      background: ${color.green} !important;
      box-shadow: 0 12px 28px #00000026;
    `) : `background: ${color.greyLight} !important;`)};
  transition: all .5s ease !important;
  text-align: center;
  padding: ${mobileVW(50)} ${mobileVW(50)} !important;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  border-radius: ${mobileVW(17)} !important;
  overflow: hidden;
  color: ${color.green} !important;

  /* &:hover  {
    background: ${(props) => (props.background ? color.green : '#42ae3124')} */

  & + & {
    ${maxTablet} {
      margin-top: ${mobileVW(15)};
    }
  }

  ${minTablet} {
    padding: ${desktopVW(40)} !important;
    border-radius: ${desktopVW(17)} !important;

    & + & {
      margin-left: ${desktopVW(15)};
    }
  };

`;

const StyledIcon = styled.div`
  border-radius: 50%;
  background: ${color.white};
  width: ${mobileVW(55)};
  height: ${mobileVW(55)};
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: ${font.weightExtraBold};
  font-family: ${font.familyExtraBold};
  font-size: ${mobileVW(29)};
  margin-bottom: ${mobileVW(15)};
  color: ${color.black};

  ${minTablet} {
    font-size: ${desktopVW(29)};
    margin-bottom: ${desktopVW(15)};
    width: ${desktopVW(55)};
    height: ${desktopVW(55)};
  }
`;

const StyledTypography = styled(Typography)`
  font-size: ${mobileVW(21)};
  width: ${mobileVW(140)};

  color: ${({ colorStyle } : {colorStyle: boolean}) => (colorStyle ? '#fff' : color.black)} !important;
  transition: color .35s cubic-bezier(0.46, 0, 0.31, 1) !important;

  ${minTablet} {
    font-size: ${desktopVW(23)};
    width: ${desktopVW(140)};
  }
`;

const StyledBody = styled.p`
  ${introSm};
  line-height: ${mobileVW(18)} !important;
  margin: ${mobileVW(30)} 0;
  width: 110%;
  color: ${({ colorStyle } : {colorStyle: boolean}) => (colorStyle ? '#fff' : color.black)} !important;
  transition: color .35s cubic-bezier(0.46, 0, 0.31, 1) !important;

  ${minTablet} {
    line-height: ${desktopVW(20)} !important;
    margin: ${desktopVW(30)} 0;
  }
`;

const MostSelected = styled(Typography)`
  background: ${color.black};
  color: ${color.white};
  padding: ${mobileVW(8)} ${mobileVW(50)};

  transform: rotate(36deg);
  position: absolute;
  top: ${mobileVW(120)};
  right: ${mobileVW(-47)};
  transform-origin: top right;
  font-weight: 400;
  text-transform: uppercase;

  ${minTablet} {
    transform: rotate(30deg);
    text-transform: lowercase;
    padding: ${desktopVW(2)} ${desktopVW(40)};
    top: ${desktopVW(85)};
    right: ${desktopVW(-40)};
  }
`;
